import { useUserQuery } from '@/api/user/useUserQuery';
import { getOrganizationId, setOrganizationId } from '@/context/authClient';
import type { OrganizationEntry } from '@/api/user/types';

interface OrganizationGateResult {
  isLoading: boolean;
  needsSelection: boolean;
  organizations: OrganizationEntry[];
}

export function useOrganizationGate(): OrganizationGateResult {
  const { data: user, isLoading } = useUserQuery();

  if (isLoading || !user) {
    return { isLoading: true, needsSelection: false, organizations: [] };
  }

  const orgs = user.organizations ?? [];
  const storedOrgId = getOrganizationId();

  // Auto-select if user has exactly one organization
  if (orgs.length === 1 && storedOrgId !== orgs[0].id) {
    setOrganizationId(orgs[0].id);
    return { isLoading: false, needsSelection: false, organizations: orgs };
  }

  // Need picker if multiple orgs and none selected (or stored ID is invalid)
  if (
    orgs.length > 1 &&
    (!storedOrgId || !orgs.some((o) => o.id === storedOrgId))
  ) {
    return { isLoading: false, needsSelection: true, organizations: orgs };
  }

  return { isLoading: false, needsSelection: false, organizations: orgs };
}
